import { useCallback, useContext, useEffect, useState } from 'react';
import { PageState, SnackbarColor } from '../../js/types';
import { SignalRToolContextType, useSignalRTool } from '../../js/SignalR/SignalRContext';
import { useSystemParamApi } from '../../js/adapter/SystemParamAdapter';
import { ResultObj } from '../../js/Domain';
import { Badge, Box, IconButton } from '@material-ui/core';
import { Close, NotificationsRounded, Refresh } from '@material-ui/icons';
import { HintBellLogSearchParams, HintBellLogSearchResItem, HintBellLogSearchResItemHintbell, useHintBellApi } from '../../js/adapter/HintBellAdapter';
import { BulletinSearchParams, BulletinSearchResItemBulletin, useBulletinApi } from '../../js/adapter/BulletinAdapter';
import { SnackbarDialogTS } from '../../_AAA/components/ReactDialogTS';
import { HintBellModalName as ModalName } from './consts';
import ModalHintBell from './ModalHintBell';
import { HintType } from './consts';
import { SearchFileResItem, useFilesApi } from '../../js/adapter/FilesAdapter';
import { autoThrowError } from '../../js/function';
import { useApiVersion } from '../../js/hooks';
import { MainPageDialogContext } from '../../js/MainPageDialogContext';
import { useSnackbar } from 'notistack';

interface ModalState {
    [ModalName.HINT_BELL]: boolean;
}

export interface MessageData {
    [HintType.HR]: { data: HintBellLogSearchResItemHintbell[], unread_count: number, totalPage: number };
    [HintType.SIGN_OFF]: { data: HintBellLogSearchResItemHintbell[], unread_count: number, totalPage: number };
    [HintType.PDI]: { data: HintBellLogSearchResItemHintbell[], unread_count: number, totalPage: number };
    [HintType.BULLTIN]: { data: BulletinSearchResItemBulletin[], unread_count: number, totalPage: number };
    [HintType.NOTICE]: { data: HintBellLogSearchResItemHintbell[], unread_count: number, totalPage: number };
}
export interface MessageSearch {
    [HintType.HR]: HintBellLogSearchParams;

    [HintType.SIGN_OFF]: HintBellLogSearchParams;
    [HintType.PDI]: HintBellLogSearchParams;
    [HintType.BULLTIN]: BulletinSearchParams;
    [HintType.NOTICE]: HintBellLogSearchParams;
}

const MessageBadge = () => {
    const signalRcontext: SignalRToolContextType = useSignalRTool();
    const { connection, connectState } = signalRcontext;
    const systemParamApiManager = useSystemParamApi();
    const hintBellApiManager = useHintBellApi();
    const bulletinApiManager = useBulletinApi();
    const filesApiManager = useFilesApi();
    const { isDotNet6AMNVersion } = useApiVersion();
    const { responseMessage } = useContext(MainPageDialogContext);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [pageState, setPageState] = useState<PageState>({
        isModalLoaded: false,
        modal: null,
        modalOpen: false,
        isLoaded: false,
        openDialog: false,
        dialogInfo: null
    });

    //modal開關控制
    const [modalState, setModalState] = useState<ModalState>({
        [ModalName.HINT_BELL]: false,
    })

    /**所有通知訊息 */
    const [messageData, setMessageData] = useState<MessageData>({} as MessageData);

    /** 當前訊息搜尋頁面資訊 */
    const [messageSearch, setMessageSearch] = useState<MessageSearch>({
        [HintType.HR]: { sps_code: HintType.HR, page: 1, num_per_page: 10 },
        [HintType.SIGN_OFF]: { sps_code: HintType.SIGN_OFF, page: 1, num_per_page: 10 },
        [HintType.PDI]: { sps_code: HintType.PDI, page: 1, num_per_page: 10 },
        [HintType.BULLTIN]: { page: 1, num_per_page: 10, subject: "", valid_date_start: "", valid_date_end: "" },
        [HintType.NOTICE]: { is_notice_only: "Y", page: 1, num_per_page: 10 }
    });

    /**公佈欄檔案 */
    const [bulletinfileList, setBulletinfileList] = useState<{ [key: string]: SearchFileResItem[] }>({});

    /**小鈴鐺有什麽類型的訊息 */
    const [messageTypes, setMessageTypes] = useState<HintType[]>([])

    /** 設置modal開關 */
    const setModalOpen = (modalName: ModalName, open: boolean) => {
        setModalState(prev => ({
            ...prev,
            [modalName]: open
        }))
    };

    /** 訊息被讀取時 */
    const onMessageRead = async (message: BulletinSearchResItemBulletin | HintBellLogSearchResItemHintbell, type: HintType) => {

        let messageId: string = ''
        if (type === HintType.BULLTIN) {
            messageId = (message as BulletinSearchResItemBulletin).bulletin_id;
        } else {
            messageId = String((message as HintBellLogSearchResItemHintbell).hbrl_id);
        }
        try {
            if (type === HintType.BULLTIN) {

                //檢查是否已經有對應id的公佈欄檔案，如果沒有則查詢
                if (!Object.keys(bulletinfileList).some(key => key === messageId)) {
                    const { data: resFile } = await autoThrowError(filesApiManager.SearchFile({
                        file_id: '',
                        belong: "Bulletin",
                        type: "流程附檔",
                        id: messageId,
                        cre_time_start: '',
                        cre_time_end: '',
                        blob: false,
                    }))
                    //將查詢到的檔案存入bulletinfileList
                    setBulletinfileList(prev => ({
                        ...prev,
                        [messageId]: resFile
                    }));
                }

                //如果已經讀取過，則不再處理
                if (message.is_read === "Y") return;

                await bulletinApiManager.BulletinRead({ bulletin_ids: [messageId] });

                //將指定訊息的is_read設置為Y
                setMessageData(prev => {
                    const updatedBulltinList = (prev[HintType.BULLTIN].data || []).map(item => {
                        if (item.bulletin_id === messageId) {
                            return { ...item, is_read: "Y" };
                        }
                        return item;
                    });
                    return {
                        ...prev,
                        [HintType.BULLTIN]: { data: updatedBulltinList, unread_count: prev[HintType.BULLTIN].unread_count - 1, totalPage: prev[HintType.BULLTIN].totalPage }
                    };
                });

            } else {
                //如果已經讀取過，則不再處理
                if (message.is_read === "Y") return;

                await hintBellApiManager.HintBellLogRead({ hbrl_id: Number(messageId) });
                //將指定訊息的is_read設置為Y
                setMessageData(prev => {
                    const updatedList = (prev[type].data || []).map(item => {
                        if (item.hbrl_id === Number(messageId)) {
                            return { ...item, is_read: "Y" };
                        }
                        return item;
                    });
                    return {
                        ...prev,
                        [type]: { data: updatedList, unread_count: prev[type].unread_count - 1, totalPage: prev[type].totalPage }
                    };
                });
            }
        } catch (error) {
            responseMessage(error as ResultObj);
        }
    }

    const handleChangePage = async (nowPage: Number, type: HintType) => {
        const newParams = { ...messageSearch[type], page: nowPage };
        try {
            if (type === HintType.BULLTIN) {
                const { data: resBullint, page: resBullintListPage = 1 } = await bulletinApiManager.BulletinSearch(newParams as BulletinSearchParams);
                setMessageData(prev => ({
                    ...prev,
                    [HintType.BULLTIN]: { data: resBullint.bulletins, unread_count: resBullint.unread_count, totalPage: resBullintListPage }
                }));
            } else {
                const { data: resMessage, page: resMessageDataPage = 1 } = await hintBellApiManager.HintBellLogSearch(newParams as HintBellLogSearchParams);
                setMessageData(prev => ({
                    ...prev,
                    [type]: { data: resMessage.hintbells, unread_count: resMessage.unread_count, totalPage: resMessageDataPage }
                }));
            }
        } catch (error) {
            responseMessage(error as ResultObj);
        }

        setMessageSearch(prev => {
            return {
                ...prev,
                [type]: newParams
            };
        });
    }

    /**獲取公佈欄通知 */
    const getBulletin = useCallback(async () => {
        if (!!bulletinApiManager && pageState.isLoaded) {
            try {
                //獲取公佈欄通知
                const { data: resBullint, page: resBullintListPage = 1 } = await bulletinApiManager.BulletinSearch(messageSearch[HintType.BULLTIN]);
                setMessageData(prev => ({
                    ...prev,
                    [HintType.BULLTIN]: { data: resBullint.bulletins, unread_count: resBullint.unread_count, totalPage: resBullintListPage }
                }));
            } catch (error) {
                responseMessage(error as ResultObj);
            }
        }
    }, [JSON.stringify(messageSearch[HintType.BULLTIN]), pageState.isLoaded, bulletinApiManager, responseMessage]);

    const getHintBell = useCallback(async (type: HintType) => {
        if (hintBellApiManager) {
            try {
                const { data: resMessage, page: resMessageDataPage = 1 } = await hintBellApiManager.HintBellLogSearch(messageSearch[type]);
                setMessageData(prev => ({
                    ...prev,
                    [type]: { data: resMessage.hintbells, unread_count: resMessage.unread_count, totalPage: resMessageDataPage }
                }));
            } catch (error) {
                responseMessage(error as ResultObj);
            }
        }
    }, [JSON.stringify(messageSearch), hintBellApiManager, responseMessage]);

    useEffect(() => {

        //初始化
        const init = async () => {

            try {
                const { data: resSecondList } = await autoThrowError(systemParamApiManager.SecondList({ spp_id: "HBT", visible: "Y" }));

                // 通知類型
                const typeSet: Set<string> = resSecondList.reduce(function (acc: Set<string>, curr: any) {
                    //有些資料類型會設爲空字串，這裏會需要過濾掉不顯示
                    if (curr.code !== "") {
                        acc.add(curr.code);
                    }
                    return acc;
                }, new Set<string>());
                const typeArr = [...Array.from(typeSet) as HintType[], ...(isDotNet6AMNVersion ? [] : [HintType.BULLTIN, HintType.NOTICE])]
                setMessageTypes(typeArr);

                // 並行查詢所有類型，獲取簽核與知悉通知
                await Promise.all(typeArr.map(type => getHintBell(type)));
            } catch (error) {
                responseMessage(error as ResultObj);
            } finally {
                setPageState(prev => ({
                    ...prev,
                    isLoaded: true
                }))
            }
        }

        //未載入過頁面，apiManager已經初始化，且連線signalR已經連綫才可以初始化
        if (!pageState.isLoaded && systemParamApiManager && hintBellApiManager) {
            init()
        }
    }, [messageSearch, pageState.isLoaded, systemParamApiManager, hintBellApiManager, getHintBell, responseMessage]);

    useEffect(() => {
        const signalR = async () => {

            if (!connection || !connectState) return;
            // 來自公告欄的通知
            connection.on("throwBulletinInformation", () => {
                //檢查小鈴鐺目前是否開啓中
                const modal = document.getElementById('ModalHintBell')
                if (modal) {//如有開啓則跳出snackbar提示用戶有新通知
                    enqueueSnackbar(`公佈欄有新訊息，請點擊按鈕重整`, {
                        variant: SnackbarColor.success, // 顏色
                        autoHideDuration: 5000,
                        action: key => ( // 錯誤通知 + 查看詳細
                            <Box>
                                <IconButton onClick={() => {
                                    setBulletinfileList({});//清空公佈欄檔案快取，避免讀取錯誤
                                    getBulletin();
                                    closeSnackbar(key);
                                }}>
                                    <Refresh style={{ color: "#fff" }} />
                                </IconButton>

                                <IconButton onClick={() => { closeSnackbar(key) }}>
                                    <Close style={{ color: "#fff" }} />
                                </IconButton>
                            </Box>
                        )
                    });
                } else {
                    //如沒有開啓則直接重新呼叫API取最新資料
                    setBulletinfileList({});//清空公佈欄檔案快取，避免讀取錯誤
                    getBulletin();

                }
            });

            // 其他通知
            connection.on("throwHintBellLog", (data: { data: HintBellLogSearchResItemHintbell } | { data: HintBellLogSearchResItemHintbell[] }) => {
                const newMessage = Array.isArray(data.data) ? data.data[0] : data.data;
                if (!newMessage) return;
                //檢查小鈴鐺目前是否開啓中
                const modal = document.getElementById('ModalHintBell')
                if (modal) {//如有開啓則跳出snackbar提示用戶有新通知
                    enqueueSnackbar(`${newMessage.is_notice_only === 'Y' ? HintType.NOTICE : newMessage.sps_code}有新訊息，請點擊按鈕重整`, {
                        variant: SnackbarColor.success, // 顏色
                        autoHideDuration: 10000,
                        action: key => ( // 錯誤通知 + 查看詳細
                            <Box>
                                <IconButton onClick={() => {
                                    if (newMessage.is_notice_only === 'Y') {
                                        //知悉通知
                                        getHintBell(HintType.NOTICE);
                                    } else {
                                        //其他通知
                                        getHintBell(newMessage.sps_code as HintType);
                                    }
                                    closeSnackbar(key);
                                }}>
                                    <Refresh style={{ color: "#fff" }} />
                                </IconButton>

                                <IconButton onClick={() => { closeSnackbar(key) }}>
                                    <Close style={{ color: "#fff" }} />
                                </IconButton>
                            </Box>
                        )
                    });
                } else {
                    //如沒有開啓則直接重新呼叫API取最新資料
                    if (newMessage.is_notice_only === 'Y') {
                        //知悉通知
                        getHintBell(HintType.NOTICE);
                    } else {
                        //其他通知
                        getHintBell(newMessage.sps_code as HintType);
                    }
                }

            });
        }
        if (connection && connectState && pageState.isLoaded) {
            signalR();
        }

    }, [connection, connectState, getBulletin, getHintBell, enqueueSnackbar, closeSnackbar, pageState.isLoaded]);

    useEffect(() => {
        getBulletin();
    }, [getBulletin])

    // 計算所有類型未讀訊息總數
    const unreadMessagesNum = Object.values(messageData).reduce(
        (sum, items) => sum + items.unread_count,
        0
    );
    return (
        <>
            <Badge
                overlap="rectangular"
                badgeContent={unreadMessagesNum > 99 ? '99+' : unreadMessagesNum}
                max={999}
                invisible={unreadMessagesNum === 0}
                color="error"
                style={{ margin: "0 1rem", cursor: "pointer" }}
                onClick={() => setModalOpen(ModalName.HINT_BELL, true)}>
                <IconButton
                    aria-label="Noti"
                    color="inherit"
                    style={{ padding: "0", marginRight: "5px" }}
                >
                    <NotificationsRounded />
                </IconButton>
            </Badge>
            {
                modalState[ModalName.HINT_BELL] &&
                <ModalHintBell
                    messageSearch={messageSearch}
                    bulletinfileList={bulletinfileList}
                    onMessageRead={onMessageRead}
                    messageData={messageData}
                    handleChangePage={handleChangePage}
                    modalClose={() => setModalOpen(ModalName.HINT_BELL, false)}
                    messageTypes={messageTypes}
                    setMessageSearch={(type: HintType, message: MessageSearch[HintType]) => {
                        setMessageSearch(prev => ({
                            ...prev,
                            [type]: message,
                        }));
                    }}
                />
            }

            <SnackbarDialogTS
                dialogInfo={pageState.dialogInfo}
                openDialog={pageState.openDialog}
                maxWidth="xs"
                closeClick={() => setPageState(prev => ({
                    ...prev,
                    openDialog: false
                }))}
                color="primary"
            />
        </>
    );
};

export default MessageBadge;